import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-24 relative" data-id="element-159">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-brand-panel border border-brand-panelBorder rounded-3xl p-10 lg:p-16 relative overflow-hidden" data-id="element-161">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-red via-brand-gray to-brand-green" data-id="element-162" />

          <p className="text-xl text-brand-gray mb-8" data-id="element-163">
            The truth is, having a $300 wearable on your finger doesn't make you
            a biohacker. It makes you a data-watcher.
          </p>

          <h2 className="text-3xl lg:text-5xl font-bold leading-tight mb-8" data-id="element-164">
            You don't have a sleep problem.
            <br data-id="element-165" />
            <span className="text-brand-green" data-id="element-166">
              You have a Translation Problem.
            </span>
          </h2>

          <p className="text-lg text-brand-gray max-w-2xl mx-auto" data-id="element-167">
            Most people use Oura or Whoop like a high-tech "I told you so"
            machine. They see the low HRV. They see the lack of Deep Sleep. They
            try "sleep hygiene," blue-light blockers, and melatonin—yet the
            scores stay in the red.
          </p>

          <div className="mt-10 inline-block bg-[#050505] border border-brand-panelBorder rounded-xl px-6 py-4 font-mono text-sm text-brand-gray" data-id="element-168">
            <span className="text-white" data-id="element-169">STATUS:</span> Measuring biology
            without a steering wheel.
          </div>
        </motion.div>
      </div>
    </section>;
}